import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusCircle, faPlusCircle } from '@fortawesome/free-solid-svg-icons';

import ReactDatePicker from 'react-datepicker';
import '../signiteCandidateForm.css';
import { FieldArray, Formik } from 'formik';
import { PersonalDetailsValidationSchema } from '../../validations/personalDetailsValidator';
import JSONPretty from 'react-json-pretty';
import { getErrorClass, getErrorMessage } from '../../../../../utils/errorUtils';
import { reverseTransformPersonalInformation } from '../../transformers/cadiateDataTransformer';
import { useSearchParams } from 'react-router-dom';
import { CandidateService } from '../../../../../services/candidateService';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addCandidate } from '../../../../../redux/slices/personalDetailSlice';
import { addWorkExperience } from '../../../../../redux/slices/WorkExperienceSlice';
import { addEducationDetails } from '../../../../../redux/slices/educationalQualificationSlice';
import { addValueAdds } from '../../../../../redux/slices/valueAddsSlice';
import { addCompensationDetails } from '../../../../../redux/slices/compensationDetailsSlice';
import Loader from 'react-spinner-loader';
import { MasterDataService } from '../../../../../services/masterDataService';
import { ResumeService } from '../../../../../services/resumeServices';
import { updateCandidateNavigation } from '../../../../../redux/slices/candidateNavigationUpdate';
import { Button } from 'react-bootstrap';
import { validateCandidateJson } from '../../../../../utils/dataCompletionValidator';

const CandidatePersonalInfoForm = ({ componentRef, onSubmit, personalDetails, saveCurrentValues }) => {
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [countryCodes, setCountryCodes] = useState([]);
  const [countries, setCountries] = useState([]);
  const [candidateId, setCandidateId] = useState("");
  const candidateFromStore = useSelector((state) => state.personalDetails)
  const [resumeFile, setResumeFile] = useState(null)
  const [candidateData, setCandidateData] = useState(
    personalDetails && reverseTransformPersonalInformation(personalDetails.personalDetails)
  );
  const candidateIdentifier = useSelector((state) => state.personalDetails?.candidateId);
  useEffect(() => {
    setCandidateId(candidateIdentifier);
  }, [candidateIdentifier])
  useEffect(() => {
    const candidateId = searchParams.get('candidateId');

    if (candidateId) {
      setLoader(true);
      setCandidateId(candidateIdentifier);
      dispatch(updateCandidateNavigation(candidateId));
      CandidateService.getCandidateById(candidateId)
        .then((response) => {
          setCandidateData(
            response.data.candidates[0].candidate.personalDetails &&
            reverseTransformPersonalInformation(response.data.candidates[0].candidate.personalDetails)
          );
          dispatch(addCandidate(response.data.candidates[0]));
          dispatch(addWorkExperience(response.data.candidates[0]));
          dispatch(addEducationDetails(response.data.candidates[0]));
          dispatch(addValueAdds(response.data.candidates[0]));
          dispatch(addCompensationDetails(response.data.candidates[0]));
          setLoader(false);
        })
        .catch((err) => {
          console.error(err);
          setLoader(false);
          alert('An error occured while fetching candidate data.');
        });
    }
    CandidateService.getAllCallingCodes().then((data) => {
      setCountryCodes(data.data);
    });
    MasterDataService.getAllCountries().then((data) => setCountries(['--Select--', ...(data.data || [])]));
  }, []);

  const subtractYears = (date, years) => {
    date.setFullYear(date.getFullYear() - years);
    return date;
  };

  const downloadFile = (resumePath, fileName) => {
    CandidateService.downloadResume(encodeURI(resumePath))
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => console.error(err));
  };

  let initialValues = {
    salutation: '',
    firstName: '',
    phoneNumbers: [{ countryCode: '91', phoneNumber: '' }],
    emailIds: [''],
    lastName: '',
    gender: '',
    maritalStatus: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    pincode: '',
    permAddress1: '',
    permAddress2: '',
    permCity: '',
    permPincode: '',
    permState: '',
    dob: '',
  };

  return (
    <>
      <Formik
        initialValues={candidateData || initialValues}
        innerRef={componentRef}
        enableReinitialize="true"
        onSubmit={async (data) => {
          onSubmit(data, 'personal-details');
        }}
        validationSchema={PersonalDetailsValidationSchema}
      >
        {({ values, handleChange, handleBlur, errors, touched, setFieldValue }) => {

          const scheduleCallHandler = (data) => {
            setLoader(false);
          }
          const handleResumeParserResponse = (data, resume) => {
            const candidate = data?.candidate;

            if (!candidate) {
              console.error("Candidate missing in response", data);
              setLoader(false);
              return;
            }
            if (candidate) {
              const missingFields = validateCandidateJson(candidate);
              if (missingFields && missingFields.length > 0) {
                const userConfirmed = window.confirm("Some required fields are still missing, may i call the candidate to collect those?");
                if (userConfirmed) {
                  setLoader(true);
                  ResumeService.scheduleCall(candidateId, candidate, scheduleCallHandler, setLoader).then(data =>
                    console.log(data)
                  );
                }
              }
            }

            candidate.personalDetails.resume = resume
            setCandidateData(
              candidate.personalDetails &&
              reverseTransformPersonalInformation(candidate.personalDetails)
            );

            const updatedCandidate = {
              ...candidateFromStore,
              candidate: {
                personalDetails: { ...candidate.personalDetails, resume: resume },
                educationalDetails: { ...candidate.educationalDetails },
                workExperience: { ...candidate.workExperience },
                compensationDetails: { ...candidate.compensationDetails },
                valueAdds: { ...candidate.valueAdds }
              }
            }
            dispatch(addCandidate(updatedCandidate));
            dispatch(addWorkExperience(updatedCandidate));
            dispatch(addEducationDetails(updatedCandidate));
            dispatch(addValueAdds(updatedCandidate));
            dispatch(addCompensationDetails(updatedCandidate));
            setLoader(false);
          }


          const fileUploadHandler = (data) => {
            if (data) {
              setFieldValue(`resume`, [data]);
              setResumeFile([data]);
              const userConfirmed = window.confirm("Do you want to auto-populate fields using the resume?");
              if (userConfirmed) {
                setLoader(true)
                if (candidateId) {
                  const parserRequest = {
                    candidateId: candidateId,
                    resumeText: data.fileTextContent
                  }


                  ResumeService.parseToJson(parserRequest, handleResumeParserResponse, [data], setLoader).catch(e =>
                    setLoader(false)
                  );
                }
              }


            }
          };


          const handleFileSelect = async (event) => {
            const file = event.target.files[0];
            if (!file) return;

            const formData = new FormData();

            formData.append("file", file);

            setLoader(true);
            CandidateService.uploadFileV2(formData, candidateId, "RESUME", fileUploadHandler, setLoader)

          };

          const handlePinChange = (type, pin) => {
            MasterDataService.getPinDetail(pin)
              .then((data) => {
                if (data.data) {
                  switch (type) {
                    case 'perm':
                      setFieldValue('permState', data.data.state);
                      setFieldValue('permCity', data.data.district);
                      break;
                    case 'current':
                      setFieldValue('state', data.data.state);
                      setFieldValue('city', data.data.district);
                      break;
                  }
                } else {
                  if (pin.length < 6 || pin.length > 6) {
                    alert('Please enter a valid pin code.');
                  }
                }
              })
              .catch((err) => {
                alert('Please enter a valid pin code.');
                switch (type) {
                  case 'perm':
                    setFieldValue('permState', '');
                    setFieldValue('permCity', '');
                    break;
                  case 'current':
                    setFieldValue('state', '');
                    setFieldValue('city', '');
                    break;
                }
              });
          };
          saveCurrentValues(values);
          return (
            <>
              <Loader show={loader} type="body" stack="vertical" message="Loading Data" />
              {window.debug && window.debug == true && (
                <Card className="mb-3">
                  <Card.Title>DEBUG</Card.Title>
                  <Card.Body className="side-pad-24">
                    <JSONPretty data={values}></JSONPretty>
                    <JSONPretty data={errors}></JSONPretty>
                    <JSONPretty data={touched}></JSONPretty>
                  </Card.Body>
                </Card>
              )}
              <Card>
                <Card.Title>Basic Profile</Card.Title>
                <Card.Body className="side-pad-24">
                  <form className="signite-form">
                    <Row className="mb-3">
                      <Form.Group as={Col} controlId="salutation">
                        <Row>
                          <Form.Group as={Col} controlId="salutation">
                            <Form.Label>Salutation*</Form.Label>
                            <Form.Select
                              name="salutation"
                              defaultValue=""
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.salutation}
                              className={`form-control ${getErrorClass(errors, touched, 'salutation')}`}
                            >
                              <option value="">--Select--</option>
                              <option value="DR">Dr.</option>
                              <option value="MR">Mr.</option>
                              <option value="MS">Ms.</option>
                              <option value="MRS">Mrs.</option>
                              <option value="PROF">Prof.</option>
                            </Form.Select>
                            <span className="errorMessage">{getErrorMessage(errors, touched, 'salutation')}</span>
                          </Form.Group>
                          <Form.Group as={Col} controlId="firstName">
                            <Form.Label>First Name*</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="First Name"
                              name="firstName"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.firstName}
                              maxLength={20}
                              className={`form-control ${getErrorClass(errors, touched, 'firstName')}`}
                            />
                            <span className="errorMessage">{getErrorMessage(errors, touched, 'firstName')}</span>
                          </Form.Group>
                        </Row>
                      </Form.Group>
                      <Form.Group as={Col} controlId="middleName">
                        <Form.Label>&nbsp;</Form.Label>
                        <Form.Control
                          name="middleName"
                          type="text"
                          placeholder="Middle Name"
                          maxLength={20}
                          value={values.middleName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className={`form-control ${getErrorClass(errors, touched, 'middleName')}`}
                        />
                        <span className="errorMessage">{getErrorMessage(errors, touched, 'middleName')}</span>
                      </Form.Group>
                      <Form.Group as={Col} controlId="lastName">
                        <Form.Label>Last Name*</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Last Name"
                          name="lastName"
                          maxLength={20}
                          value={values.lastName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className={`form-control ${getErrorClass(errors, touched, 'lastName')}`}
                        />
                        <span className="errorMessage">{getErrorMessage(errors, touched, 'lastName')}</span>
                      </Form.Group>
                    </Row>
                    <Row className="mb-3">
                      <Form.Group as={Col} controlId="dob">
                        <Form.Label>DOB*</Form.Label>
                        <ReactDatePicker
                          name="dob"
                          selected={values.dob ? new Date(values.dob) : ''}
                          onChange={(val) => {
                            setFieldValue('dob', val, true);
                          }}
                          onBlur={handleBlur}
                          className={`form-control ${getErrorClass(errors, touched, 'dob')}`}
                          maxDate={subtractYears(new Date(), 18)}
                          dateFormat="dd/MM/yyyy"
                          showYearDropdown
                          autoComplete="off"
                        />
                        <span className="errorMessage">{getErrorMessage(errors, touched, 'dob')}</span>
                      </Form.Group>

                      <Form.Group as={Col} controlId="gender">
                        <Form.Label>Gender*</Form.Label>
                        <Form.Select
                          name="gender"
                          defaultValue=""
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.gender}
                          className={`form-control ${getErrorClass(errors, touched, 'gender')}`}
                        >
                          <option value="">--Select--</option>
                          <option value="MALE">Male</option>
                          <option value="FEMALE">Female</option>
                          <option value="DONT_WANT_TO_SPECIFY">Don't Want to Specify</option>
                        </Form.Select>
                        <span className="errorMessage">{getErrorMessage(errors, touched, 'gender')}</span>
                      </Form.Group>
                      <Form.Group as={Col} controlId="formMarritalStatus">
                        <Form.Label>Marital Status</Form.Label>

                        <Form.Select
                          defaultValue=""
                          name="maritalStatus"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.maritalStatus}
                          className={`form-control ${getErrorClass(errors, touched, 'maritalStatus')}`}
                        >
                          <option value="">--Select--</option>
                          <option value="MARRIED">Married</option>
                          <option value="SINGLE">Single</option>
                          <option value="DONT_WANT_TO_SPECIFY">Don't want to specify</option>
                        </Form.Select>
                        <span className="errorMessage">{getErrorMessage(errors, touched, 'maritalStatus')}</span>
                      </Form.Group>
                    </Row>
                    <hr style={{ marginTop: 32, marginBottom: 32 }} />
                    <h5 className="signite-h5">Contact Details</h5>
                    <Row className="mb-3">
                      <Col>
                        <Form.Group as={Col} controlId="addMobile">
                          <FieldArray name="phoneNumbers">
                            {({ remove, push }) => (
                              <>
                                {values.phoneNumbers &&
                                  values.phoneNumbers.length > 0 &&
                                  values.phoneNumbers.map((phoneNumber, index) => (
                                    <Row key={`phone-${index}`}>
                                      <Col md={4} lg={4}>
                                        <Form.Label>Country Code*</Form.Label>
                                        <Form.Select
                                          name={`phoneNumbers.${index}.countryCode`}
                                          value={phoneNumber.countryCode}
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          className={`form-control ${getErrorClass(
                                            errors,
                                            touched,
                                            `phoneNumber.${index}.countryCode`
                                          )}`}
                                        >
                                          {countryCodes.map((countryCode, index) => (
                                            <option value={countryCode.callingCode} key={index}>
                                              {countryCode.displayText}
                                            </option>
                                          ))}
                                        </Form.Select>
                                      </Col>
                                      <Col md={5} lg={5}>
                                        <Form.Label>
                                          Phone Number {`${index == 0 ? '(Primary)' : index + 1}`}*
                                        </Form.Label>
                                        <Form.Control
                                          name={`phoneNumbers.${index}.phoneNumber`}
                                          value={phoneNumber.phoneNumber}
                                          onChange={handleChange}
                                          type="number"
                                          onBlur={handleBlur}
                                          className={`form-control ${getErrorClass(
                                            errors,
                                            touched,
                                            `phoneNumbers.${index}.countryCode`
                                          )}`}
                                        ></Form.Control>
                                        <span className="errorMessage">
                                          {getErrorMessage(errors, touched, `phoneNumbers.${index}`)}
                                        </span>
                                      </Col>
                                      <Col className="d-flex align-items-center" style={{ paddingTop: 7 }}>
                                        {index > 0 ? (
                                          <a className="signiteLink" onClick={() => remove(index)}>
                                            <FontAwesomeIcon icon={faMinusCircle} size="sm" />
                                          </a>
                                        ) : null}
                                      </Col>
                                    </Row>
                                  ))}
                                <Row>
                                  <Col>
                                    <a
                                      className="signiteLink"
                                      onClick={() => {
                                        !values.phoneNumbers || values.phoneNumbers.length < 3
                                          ? push({ countryCode: '91', phoneNumber: '' })
                                          : null;
                                      }}
                                    >
                                      <FontAwesomeIcon icon={faPlusCircle} size="sm" />
                                      <span>Add Phone Number</span>
                                    </a>
                                  </Col>
                                </Row>
                              </>
                            )}
                          </FieldArray>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group as={Col} controlId="emailIds">
                          <FieldArray name="emailIds">
                            {({ remove, push }) => (
                              <>
                                {values.emailIds &&
                                  values.emailIds.length > 0 &&
                                  values.emailIds.map((emailId, index) => (
                                    <Row key={`emailId-${index}`}>
                                      <Col md={9} lg={9}>
                                        <Form.Label>Email ID {`${index == 0 ? '(Primary)' : index + 1}`}*</Form.Label>
                                        <Form.Control
                                          name={`emailIds.${index}`}
                                          value={emailId}
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          className={`form-control ${getErrorClass(
                                            errors,
                                            touched,
                                            `emailIds.${index}`
                                          )}`}
                                        ></Form.Control>
                                        <span className="errorMessage">
                                          {getErrorMessage(errors, touched, `emailIds.${index}`)}
                                        </span>
                                      </Col>
                                      <Col className="d-flex align-items-center" style={{ paddingTop: 7 }}>
                                        {index > 0 ? (
                                          <a className="signiteLink" onClick={() => remove(index)}>
                                            <FontAwesomeIcon icon={faMinusCircle} size="sm" />
                                          </a>
                                        ) : null}
                                      </Col>
                                    </Row>
                                  ))}
                                <Row>
                                  <Col>
                                    <a
                                      className="signiteLink"
                                      onClick={() => (!values.emailIds || values.emailIds.length < 3 ? push('') : null)}
                                    >
                                      <FontAwesomeIcon icon={faPlusCircle} size="sm" />
                                      <span>Add Email ID</span>
                                    </a>
                                  </Col>
                                </Row>
                              </>
                            )}
                          </FieldArray>
                        </Form.Group>
                      </Col>

                      <Form.Group as={Col} controlId="blank"></Form.Group>
                    </Row>
                    <Row className="mb-3">
                      <Form.Group as={Col} controlId="blank"></Form.Group>
                    </Row>
                    <hr style={{ marginTop: 32, marginBottom: 32 }} />
                    <h5 className="signite-h5">Current Address</h5>
                    <Row className="mb-3">
                      <Form.Group as={Col} controlId="formGridEmail">
                        <Form.Label>Address Line 1</Form.Label>
                        <Form.Control
                          type="text"
                          name="address1"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.address1}
                          className={`form-control ${getErrorClass(errors, touched, 'address1')}`}
                        ></Form.Control>
                        <span className="errorMessage">{getErrorMessage(errors, touched, 'address1')}</span>
                      </Form.Group>
                      <Form.Group as={Col} controlId="address2">
                        <Form.Label>Address Line 2</Form.Label>
                        <Form.Control
                          type="text"
                          name="address2"
                          value={values.address2}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className={`form-control ${getErrorClass(errors, touched, 'address2')}`}
                        ></Form.Control>
                        <span className="errorMessage">{getErrorMessage(errors, touched, 'address2')}</span>
                      </Form.Group>
                      <Form.Group as={Col} controlId="pincode">
                        <Form.Label>Country*</Form.Label>
                        <Form.Select
                          name="country"
                          value={values.country}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className={`form-control ${getErrorClass(errors, touched, 'country')}`}
                        >
                          {countries &&
                            countries.map((country) => (
                              <option value={country === '--Select--' ? '' : country}>{country}</option>
                            ))}
                        </Form.Select>

                        <span className="errorMessage">{getErrorMessage(errors, touched, 'country')}</span>
                      </Form.Group>
                    </Row>
                    <Row className="mb-3">
                      <Form.Group as={Col} controlId="pincode">
                        <Form.Label>Pincode*</Form.Label>
                        <Form.Control
                          type="number"
                          name="pincode"
                          value={values.pincode}
                          max={999999}
                          min={0}
                          onBlur={(e) => {
                            handlePinChange('current', values.pincode);
                            handleBlur(e);
                          }}
                          onChange={handleChange}
                          className={`form-control ${getErrorClass(errors, touched, 'pincode')}`}
                        ></Form.Control>
                        <span className="errorMessage">{getErrorMessage(errors, touched, 'pincode')}</span>
                      </Form.Group>
                      <Form.Group as={Col} controlId="state">
                        <Form.Label>State*</Form.Label>
                        <Form.Control
                          type="text"
                          name="state"
                          value={values.state}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className={`form-control ${getErrorClass(errors, touched, 'state')}`}
                          disabled={values.country === 'India'}
                        ></Form.Control>
                        <span className="errorMessage">{getErrorMessage(errors, touched, 'state')}</span>
                      </Form.Group>
                      <Form.Group as={Col} controlId="city">
                        <Form.Label>City*</Form.Label>
                        <Form.Control
                          type="text"
                          name="city"
                          value={values.city}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className={`form-control ${getErrorClass(errors, touched, 'city')}`}
                          disabled={values.country === 'India'}
                        ></Form.Control>
                        <span className="errorMessage">{getErrorMessage(errors, touched, 'city')}</span>
                      </Form.Group>
                    </Row>
                    <Row>
                      <Form.Group as={Col} controlId="differentPermAddress">
                        <Form.Check
                          className="signite-label"
                          name="isDifferentPermanentAddress"
                          checked={values.isDifferentPermanentAddress}
                          type="checkbox"
                          label="Permanent address is different from Current address"
                          onChange={(el) => setFieldValue('isDifferentPermanentAddress', el.target.checked)}
                        />
                      </Form.Group>
                    </Row>
                    {values.isDifferentPermanentAddress && (
                      <div>
                        <hr style={{ marginTop: 32, marginBottom: 32 }} />
                        <h5 className="signite-h5">Permanent Address</h5>
                        <Row className="mb-3">
                          <Form.Group as={Col} controlId="formGridEmail">
                            <Form.Label>Address Line 1*</Form.Label>
                            <Form.Control
                              type="text"
                              name="permAddress1"
                              value={values.permAddress1}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              className={`form-control ${getErrorClass(errors, touched, 'permAddress1')}`}
                            ></Form.Control>
                            <span className="errorMessage">{getErrorMessage(errors, touched, 'permAddress1')}</span>
                          </Form.Group>
                          <Form.Group as={Col} controlId="permAddress2">
                            <Form.Label>Address Line 2</Form.Label>
                            <Form.Control
                              type="text"
                              name="permAddress2"
                              value={values.permAddress2}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              className={`form-control ${getErrorClass(errors, touched, 'permAddress2')}`}
                            ></Form.Control>
                            <span className="errorMessage">{getErrorMessage(errors, touched, 'permAddress2')}</span>
                          </Form.Group>
                          <Form.Group as={Col} controlId="permCountry">
                            <Form.Label>Country*</Form.Label>
                            <Form.Select
                              name="permCountry"
                              value={values.permCountry}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              className={`form-control ${getErrorClass(errors, touched, 'permCountry')}`}
                            >
                              {countries && countries.map((country) => <option value={country}>{country}</option>)}
                            </Form.Select>

                            <span className="errorMessage">{getErrorMessage(errors, touched, 'permCountry')}</span>
                          </Form.Group>
                        </Row>
                        <Row className="mb-3">
                          <Form.Group as={Col} controlId="permPincode">
                            <Form.Label>Pincode*</Form.Label>
                            <Form.Control
                              type="text"
                              name="permPincode"
                              value={values.permPincode}
                              onChange={handleChange}
                              onBlur={(e) => {
                                handlePinChange('perm', values.permPincode);
                                handleBlur(e);
                              }}
                              className={`form-control ${getErrorClass(errors, touched, 'permPincode')}`}
                            ></Form.Control>
                            <span className="errorMessage">{getErrorMessage(errors, touched, 'permPincode')}</span>
                          </Form.Group>
                          <Form.Group as={Col} controlId="permState">
                            <Form.Label>State*</Form.Label>
                            <Form.Control
                              type="text"
                              name="permState"
                              value={values.permState}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              className={`form-control ${getErrorClass(errors, touched, 'permState')}`}
                              disabled={values.permCountry === 'India'}
                            ></Form.Control>
                            <span className="errorMessage">{getErrorMessage(errors, touched, 'permState')}</span>
                          </Form.Group>
                          <Form.Group as={Col} controlId="permCity">
                            <Form.Label>City*</Form.Label>
                            <Form.Control
                              type="text"
                              name="permCity"
                              value={values.permCity}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              className={`form-control ${getErrorClass(errors, touched, 'permCity')}`}
                              disabled={values.permCountry === 'India'}
                            ></Form.Control>
                            <span className="errorMessage">{getErrorMessage(errors, touched, 'permCity')}</span>
                          </Form.Group>
                        </Row>
                      </div>
                    )}
                    <Row className="mt-3 mb-3">
                      <Col>
                        Resume:
                        {values.resume &&
                          values.resume.map((resume, index) => (
                            <div key={index}>
                              <a
                                href="#"
                                onClick={() => downloadFile(resume.path, resume.displayFileName)}
                              >
                                {resume.displayFileName}
                              </a>
                            </div>
                          ))}
                        {
                          candidateId ? (<div className="mt-2">

                            <input
                              type="file"
                              accept=".pdf,.doc,.docx"
                              onChange={handleFileSelect}
                              style={{ display: "none" }}
                              id="resumeUpload"
                            />
                            <label htmlFor="resumeUpload">
                              <Button variant="primary" as="span" disabled={loader} style={{
                                backgroundColor: '#f35824',
                                border: '1px solid #f35824',
                                borderRadius: '25px',
                                fontWeight: 600,
                                fontSize: '14px',
                                lineHeight: '18px',
                              }}>
                                {loader ? "Uploading..." : "Browse"}
                              </Button>
                            </label>
                          </div>) : (
                            <div className="mt-2">
                              <p>Please enter basic information and save before you could upload the resume.</p>
                            </div>
                          )
                        }

                        {values.resume &&
                          values.resume.map((resume, index) => (
                            <div key={index}>
                              <input
                                type="hidden"
                                name={`resume[${index}].displayFileName`}
                                value={resume.displayFileName}
                              />
                              <input
                                type="hidden"
                                name={`resume[${index}].path`}
                                value={resume.path}
                              />
                            </div>
                          ))}
                      </Col>
                    </Row>
                  </form>
                </Card.Body>
              </Card>
            </>
          );
        }}
      </Formik>
    </>
  );
};

export default CandidatePersonalInfoForm;
